<template>
  <info-dialog v-model="isActive" max-width="550px" :title="$t('reports.label.generazione_documentazione')">

    <v-flex xs12 class="font-weight-regular mb-1 pl-3">
      <span>{{ $t('reports.label.seleziona_intervallo') }}:</span>
    </v-flex>

    <v-flex sm6 xs12 class="font-weight-medium">
      <date-picker :prefix="$t('label.da') + ':'" v-model="from" :max="to" solo class="input--dense"  :locale="$i18n.locale"/>
    </v-flex>

    <v-flex sm6 xs12 class="font-weight-medium">
      <date-picker :prefix="$t('label.a') + ':'" v-model="to" :min="from" solo class="input--dense"  :locale="$i18n.locale"/>
    </v-flex>

    <v-flex xs12 class="mt-4">
      <v-btn color="info" block @click="downloadCSV" :disabled="!valid" :loading="loadingCSV">
        {{ $t('reports.label.download_dati_minimi') }} (CSV)
      </v-btn>
      <v-btn color="success" block @click="downloadExcel" :disabled="!valid" :loading="loadingExcel">
        {{ $t('reports.label.download_dati_minimi') }} (Excel)
      </v-btn>
    </v-flex>

  </info-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import InfoDialog from '@/components/base/InfoDialog'
import DatePicker from '@/components/inputs/DatePicker'

export default {
    name: 'ReportDocumentationDialog',
    mixins: [Toggleable],
    components: { DatePicker, InfoDialog },
    data: () => ({
        from: null,
        to: null,
        loadingCSV: false,
        loadingExcel: false
    }),
    computed: {
        valid () {
            return !!this.from && !!this.to
        }
    },
    methods: {
        show () {
            this.isActive = true
        },
        downloadCSV () {
            this.loadingCSV = true
            this.$api.reports.downloadDatiMinimiCSV(this.from, this.to).then(() => {
                this.loadingCSV = false
            }).catch(e => {
                this.loadingCSV = false
                this.$snackbar.showServerError(e)
            })
        },
        downloadExcel () {
            this.loadingExcel = true
            this.$api.reports.downloadDatiMinimiExcel(this.from, this.to).then(() => {
                this.loadingExcel = false
            }).catch(e => {
                this.loadingExcel = false
                this.$snackbar.showServerError(e)
            })
        }
    }
}
</script>
